<template>
  <div>
    <div class="back" @click="back">
      <i class="iconfont iconback"></i>
      <span>上一页</span>
    </div>
    <el-dialog title="系统提示" :visible.sync="dialogVisible" width="480px">
      <slot v-if="$slots.default"> </slot>

      <template v-else>
        <p class="sure">确定要返回上一页吗？</p>
        <p class="info">返回后当前页面编辑的信息将不会被保存</p>
      </template>

      <div class="btn">
        <button class="my-button-delete confim" @click="confim">确认</button>
        <button class="my-button-cancel cancel" @click="cancel">取消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },

  props: {
    isPrompt: {
      type: Boolean,
      default: false,
    },

    useDefaultBack: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    back() {
      if (!this.useDefaultBack) return this.$emit("backLastPage");
      if (this.isPrompt) {
        this.dialogVisible = true;
      } else {
        this.$router.back(-1);
      }
    },

    confim() {
      this.$emit('confirm')
      if (!this.useDefaultBack) return this.$emit("backLastPage");
      this.$router.back(-1);
      this.dialogVisible = false;
    },

    cancel() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 96px;
  height: 38px;
  cursor: pointer;

  i {
    position: relative;
    top: 3px;
    font-size: 22px;
  }

  span {
    position: relative;
    top: 1px;
    left: 2px;
    font-size: 16px;
    line-height: 38px;
  }

  &:hover {
    i,
    span {
      color: #08a681;
    }
  }

  &:active {
    i,
    span {
      color: #028e6e;
    }
  }
}
.sure {
  margin: 20px 0 12px 0;
  font-size: 20px;
  font-weight: bolder;
  line-height: 22px;
  text-align: center;
}

.info {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.btn {
  width: 208px;
  margin: 20px auto 2px auto;

  .confim,
  .cancel {
    margin: 0 5px;
  }
}
</style>